import { LocationVarKey, SpotData, SpotDataButton, SpotDataButtonStyle, SpotDataHeaderSection, SpotListingItem } from "@swivl-mono/types";
import { Link } from "react-router-dom";

export function SpotPageHeader(props: SpotData) {
  return (
    <div className="spot-page-header z-10 text-white mx-auto sticky top-0 left-0">
      <SpotPageImage {...props} />
      <SpotPageShade />
      <div className="z-20 flex flex-col items-center justify-center relative pt-20 pb-10 pl-3 pr-3">
        {props.avatarUri && (
          <div className=" relative rounded-lg bg-white w-20 h-20 overflow-hidden ">
            <img className="w-full h-full object-cover" src={props.avatarUri} alt={`${props.heading} Logo`} />
          </div>
        )}
        {props.heading && <h1 className="text-white text-2xl font-semibold mt-2">{props.heading}</h1>}
        {props.subHeading && <div className="text-white mt-2 text-center">{props.subHeading}</div>}
        <SpotPageHeaderSection {...props} />
      </div>
    </div>
  );
}

interface SpotPageHeaderSectionProps {
  headerSections?: SpotDataHeaderSection[][];
}

export function SpotPageHeaderSection(props: SpotPageHeaderSectionProps) {
  const sections = props.headerSections;
  if (!sections || !sections.length) return null;

  return (
    <div className="text-white flex justify-center items-center flex-col">
      {" "}
      {sections.map((sectionGroup: SpotDataHeaderSection[], index: number) => {
        const className =
          sectionGroup.length > 1
            ? "grid md:grid-cols-2 sm:grid-cols-1 gap-x-10 gap-y-5 pt-1 relative z-20 md:pl-15 md:pr-15 sm:pl-5 sm:pr-5"
            : "grid md:grid-cols-1 sm:grid-cols-1 gap-x-10 gap-y-5 pt-1 relative z-20 md:pl-15 md:pr-15 sm:pl-5 sm:pr-5";
        return (
          <div key={index} className={className}>
            {sectionGroup.map((section: SpotDataHeaderSection) => {
              if (section.isLink) {
                return (
                  <a key={section.id} className="flex flex-col mk1" href={section.href} target={section.target || "_self"}>
                    {section.title && (
                      <h4
                        className={
                          section.center
                            ? "text-white  text-mdsm font-bold whitespace-pre-line mb-1 text-center"
                            : "text-white text-mdsm font-bold whitespace-pre-line mb-1 text-center md:text-left"
                        }
                      >
                        {section.title}
                      </h4>
                    )}
                    {section.content && (
                      <p
                        className={
                          section.center
                            ? "text-white  text-mdsm whitespace-pre-line text-center"
                            : "text-white text-mdsm whitespace-pre-line text-center md:text-left"
                        }
                      >
                        {section.content}
                      </p>
                    )}
                  </a>
                );
              }
              return (
                <div key={section.id} className="flex flex-col">
                  {section.title && (
                    <h4
                      className={
                        section.center
                          ? "text-white  text-mdsm font-bold whitespace-pre-line mb-1 text-center"
                          : "text-white text-mdsm font-bold whitespace-pre-line mb-1 text-center md:text-left"
                      }
                    >
                      {section.title}
                    </h4>
                  )}
                  {section.content && (
                    <p
                      className={
                        section.center
                          ? "text-white  text-mdsm whitespace-pre-line text-center"
                          : "text-white text-mdsm whitespace-pre-line  text-center md:text-left"
                      }
                    >
                      {section.content}
                    </p>
                  )}
                </div>
              );
            })}
          </div>
        );
      })}
    </div>
  );
}

export function SpotPageImage(props: SpotData) {
  return (
    <div className="z-0 top-0 bottom-0 left-0 right-0 text-white w-auto absolute bg-transparent overflow-hidden">
      <img
        alt={props.heading}
        className=" z-0 bg-black object-cover  w-full h-full"
        src={props.backgroundUri ? props.backgroundUri : "/self_storage_hallway.jpg"}
      />
    </div>
  );
}

export function SpotPageShade() {
  return (
    <div className="bottom-0.5 absolute z-10 top-0 left-0 right-0 bg-white bg-opacity-0  bg-gradient-to-t to-[#00000033] from-[#000000cc]"></div>
  );
}

interface SpotLocationButtonProps {
  button: SpotDataButton;
  builderButton?: boolean;
}
export function SpotLocationButton(props: SpotLocationButtonProps) {
  const { button, builderButton } = props;
  if (builderButton) {
    const className =
      "transition-colors text-mdsm  py-[8px]  cursor-pointer w-full h-11 rounded-md flex flex-row justify-center items-center " +
      (button.style === SpotDataButtonStyle.PRIMARY ? " swivl-primary" : " swivl-secondary ");
    return (
      <div className={className}>
        {button.icon && <span className="mr-2">{button.icon}</span>}
        {button.title}
      </div>
    );
  }
  const isFirstCharacterSlash = button.href?.charAt(0) === "/";
  if (isFirstCharacterSlash) {
    const className =
      "transition-colors text-mdsm  py-[8px] mb-[10px] cursor-pointer w-full h-11 rounded-md flex flex-row justify-center items-center " +
      (button.style === SpotDataButtonStyle.PRIMARY ? " swivl-primary" : " swivl-secondary ");
    return (
      <Link className={className} to={button.href!}>
        {button.icon && <span className="mr-2">{button.icon}</span>}
        {button.title}
      </Link>
    );
  }

  const className =
    "transition-colors text-mdsm  py-[8px] mb-[10px] cursor-pointer w-full h-11 rounded-md flex flex-row justify-center items-center " +
    (button.style === SpotDataButtonStyle.PRIMARY ? " swivl-primary" : " swivl-secondary ");
  return (
    <a className={className} href={button.href} target={button.target || "_blank"}>
      {button.icon && <span className="mr-2">{button.icon}</span>}
      {button.title}
    </a>
  );
}

interface SpotLocationItemProps {
  brandSlug?: string;
  item: SpotListingItem;
}

export function SpotLocationItem({ brandSlug, item }: SpotLocationItemProps) {
  return (
    <Link to={`/${brandSlug}/${item.variables[LocationVarKey.SpotLocationSlug]}/`} className="bg-white flex flex-row w-full mb-5">
      <div className=" relative rounded-lg bg-slate-200 w-20 h-20 overflow-hidden ">
        {item.variables[LocationVarKey.AvatarURL] && (
          <img className="w-full h-full object-cover" src={item.variables[LocationVarKey.AvatarURL]} alt={`${item.location.name}`} />
        )}
      </div>
      <div className="flex flex-col justify-center items-start ml-4">
        <div className="text-base font-bold text-[#000000]">{item.location.name}</div>
        <div className="text-sm text-[#818181]">
          {item.variables[LocationVarKey.Address]} {item.variables[LocationVarKey.City]} {item.variables[LocationVarKey.State]}{" "}
          {item.variables[LocationVarKey.PostalCode]}
        </div>
        {/* <div className="text-xs text-[#818181]">{item.text}</div> */}
      </div>
    </Link>
  );
}
